import React, { useState, useEffect } from 'react'
import { Box } from '@mui/system'
import { TextField, InputLabel, FormControl, Select, MenuItem, Button } from '@mui/material'
import Sidebar from './sidebar'

import { addDoc, collection, query, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

export default function DailySumbission() {
  const [rows, setRows] = useState([])

  let arr = [];

  useEffect(() => {
    test()
  
    async function test(){
      arr=[]
      getData()
    }

    setRows(arr)
    console.log(arr)
    
  
  
  }, [])
  
  async function getData (){
    let arr = []
    const q = query(collection(db, "staff"));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      let obj = doc.data();
      Object.assign(obj, {doc: doc.id});
      console.log(obj)
      arr.push(obj)
     });  
  
     setRows(arr)
  
  }



  const [date, setdate] = useState("");
  const [name, setname] = useState("");
  const [candidates, setcandidates] = useState("")
  const [meals, setmeals] = useState("")
  const [showers, setshowers] = useState("")
  const [parcels, setparcels] = useState("")
  const [male, setmale] = useState("")
  const [female, setfemale] = useState("")
  const [others, setothers] = useState("")
  const [probaition, setprobaition] = useState("")
  const [nonClientFood, setNonClientFood] = useState("")
  const [starterPacks, setStarterPacks] = useState("")
  const [refugeeStarter, setRefugeeStarter] = useState("")
  const [sleepingBags, setSleepingBags] = useState("")

  const pushData = async () => {
    

   
    let main = {

      id: Date.now(),
      date,
      name,
      candidates,
      meals,
      showers,
      parcels,
      male,
      female,
      others,
      probaition,
      nonClientFood,
      starterPacks,
      refugeeStarter,
      sleepingBags

    }
    console.log(main)
    await addDoc(collection(db, "dailySumbissions"), main)
    reset()
  }

  let reset = () =>{
    setcandidates("")
    setdate("")
    setfemale("")
    setmale("")
    setmeals("")
    setname("")
    setothers("")
    setshowers("")
    setparcels("")
    setprobaition("")
    setNonClientFood("")
    setStarterPacks("")
    setRefugeeStarter("")
    setSleepingBags("")
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />


      <Box component="main" sx={{ flexGrow: 1, p: 3 }} style={{ marginTop: "50px", justifyContent: "center", alignItems: "center" }}>

        <div style={{ height: 640, width: '100%' }}>
          <div className='LoginPage'>
            <TextField type="date" InputLabelProps={{ shrink: true, }} className='addform' id="outlined-basic" label="Date" variant="outlined" style={{ width: "45%" }} onChange={(e) => setdate(e.target.value)} value={date} />
            <FormControl style={{ width: "45%" }}>
              <InputLabel id="demo-simple-select-label">Name </InputLabel>
              <Select
                value={name}
                onChange={(e) => setname(e.target.value)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Location"
              >
                {rows.map((v)=>{
                  return(
                    <MenuItem value={v.firstName + " " + v.surName}>{v.firstName+ " " + v.surName}</MenuItem>
                    
                  )
                })}
              </Select>
            </FormControl>

            <TextField type="number" className='addform' id="outlined-basic" label="Beneficiary Attended" variant="outlined" style={{ width: "45%" }} onChange={(e) => setcandidates(e.target.value)} value={candidates} />
            <TextField type="number" className='addform' id="outlined-basic" label="Starter Packs" variant="outlined" style={{ width: "45%" }} onChange={(e) => setStarterPacks(e.target.value)} value={starterPacks} />
            <TextField type="number" className='addform' id="outlined-basic" label="Food Parcels Provided" variant="outlined" style={{ width: "45%" }} onChange={(e) => setparcels(e.target.value)} value={parcels} />
            <TextField type="number" className='addform' id="outlined-basic" label="Non-Client Food Parcels" variant="outlined" style={{ width: "45%" }} onChange={(e) => setNonClientFood(e.target.value)} value={nonClientFood} />
            <TextField type="number" className='addform' id="outlined-basic" label="Male" variant="outlined" style={{ width: "45%" }} onChange={(e) => setmale(e.target.value)} value={male} />
            <TextField type="number" className='addform' id="outlined-basic" label="Hot Meals Provided" variant="outlined" style={{ width: "45%" }} onChange={(e) => setmeals(e.target.value)} value={meals} />
            <TextField type="number" className='addform' id="outlined-basic" label="Female" variant="outlined" style={{ width: "45%" }} onChange={(e) => setfemale(e.target.value)} value={female} />
            <TextField type="number" className='addform' id="outlined-basic" label="Showers Provided" variant="outlined" style={{ width: "45%" }} onChange={(e) => setshowers(e.target.value)} value={showers} />
            <TextField type="number" className='addform' id="outlined-basic" label="Others" variant="outlined" style={{ width: "45%" }} onChange={(e) => setothers(e.target.value)} value={others} />
            <TextField type="number" className='addform' id="outlined-basic" label="Attendees on Probation" variant="outlined" style={{ width: "45%" }} onChange={(e) => setprobaition(e.target.value)} value={probaition} />
            <TextField type="number" className='addform' id="outlined-basic" label="Refugee Starter Packs" variant="outlined" style={{ width: "45%" }} onChange={(e) => setRefugeeStarter(e.target.value)} value={refugeeStarter} />
            <TextField type="number" className='addform' id="outlined-basic" label="Sleeping Bags" variant="outlined" style={{ width: "45%" }} onChange={(e) => setSleepingBags(e.target.value)} value={sleepingBags} />
            {/* <TextField type="number" className='addform' id="outlined-basic" label="Others" variant="outlined" style={{ width: "45%", visibility: "hidden"}} onChange={(e) => setothers(e.target.value)} value={others} /> */}
            <Button onClick={pushData} className='addform' variant="contained" style={{ width: "100%", height: "50px", marginTop: "30px", backgroundColor: "#F21D2F" }}>Submit</Button>

          </div>

        </div>
      </Box>
    </Box>
  )
}
